export default __webpack_public_path__ + "static/media/hero.1d21a3cd.svg";